/** Space digits in groups of three for display. */
export const formatRegistrationNumber = (value: string) => {
  const digits = value.replace(/\s/g, '');
  return digits.replace(/(.{3})(?=.)/g, '$1 ');
};
